import classNames from "classnames";
import type React from "react";
import type { MessageOrInternalNote } from "../../common/types/Message";
import type { MessageSenderRole } from "../../common/types/Roles";
import { AgentAvatar } from "../Common/Avatar";
import ChatMessageAuthorRow from "./ChatMessageAuthorRow";
import "./ChatMessageInner.css";

type Props = {
    children: React.ReactNode;
    sender: MessageSenderRole;
    messageBase: MessageOrInternalNote;
    onRequestLinkClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
};

function ChatMessageInner(props: Props) {
    const { className, children, sender, messageBase, onRequestLinkClick } = props;
    const { sentBy, senderName } = messageBase;

    return (
        <>
            <div
                className={classNames(
                    "chat-message__inner",
                    `chat-message__inner--${sender}`,
                    className,
                )}
            >
                {children}

                {sender === "agent" && (
                    <div className="chat-message__author-avatar">
                        <AgentAvatar agentId={sentBy} alt={senderName} size="mid" />
                    </div>
                )}
            </div>

            <ChatMessageAuthorRow
                messageBase={messageBase}
                sender={sender}
                onRequestLinkClick={onRequestLinkClick}
            />
        </>
    );
}

export default ChatMessageInner;
